export const EDIT_PAUSE_DURATION_MODAL_STAGES = {
  notOpen: 'notOpen',
  update: 'update',
  success: 'success',
};
